import { Fragment } from '@/extend/vue-fragment/index'
import {topList} from '@/api/tool/video'
import './index.scss'
export default {
  props: { mini: Boolean, videoList:{
      type:Array,
      default:[]
      }},
  data() {
    return {
      drawer: {
        is: false,
      },
      list: [
        // {
        //   prop: 'HOME_GLHT_VIDEO_INSTALL_TUTORIAL',
        //   title: "",
        //   time: "2020-06-06",
        //   url: '',
        //   poster: 'https://s3.ax1x.com/2020/12/28/roQi1H.jpg'
        // },
        // {
        //   prop: 'HOME_GLHT_VIDEO_IMPORT_TUTORIAL',
        //   title: "",
        //   time: "2020-06-06",
        //   url: '',
        //   poster: 'https://s3.ax1x.com/2020/12/28/roM9Qs.jpg'
        // },
        // {
        //   prop: 'HOME_GLHT_VIDEO_INVOICE_TUTORIAL',
        //   title: "",
        //   time: "2020-06-06",
        //   url: '',
        //   poster: 'https://s3.ax1x.com/2020/12/28/roQP9e.jpg'
        // },
        // {
        //   prop: 'HOME_GLHT_VIDEO_RED_TUTORIAL',
        //   title: "",
        //   time: "2020-06-06",
        //   url: '',
        //   poster: 'https://s3.ax1x.com/2020/12/28/roQ9hD.jpg'
        // },
      ],
      player: {},
      loginResource: []
    };
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      // 临时指定域名，方便测试
      //domain = "https://magiccubex.vip";
      // this.loginResource = JSON.parse(sessionStorage.getItem('loginResource'));
      // if (!this.loginResource) return
      //
      // this.list = this.list.map((item) => {
      //   const installVideoData = this.loginResource.find(obj => obj.resources_code == item.prop) || {}
      //   item = {
      //     prop: item.prop,
      //     poster: item.poster,
      //     url: installVideoData.resources_content,
      //     title: installVideoData.resources_description,
      //     time: installVideoData.create_time,
      //   }
      //   return item
      // })
        topList(window.location.href).then(res => {
            if(res.data.code == 200){
                this.list = res.data.data;
                this.$emit("update:videoList",res.data.data[0])

            }
        })
    }
  },
  render() {
    return (
      <div class="v-tool__right">
        <ul class="animated fadeInDown">
          {
            this.list.map((item) => {
              return (<li class="animated" onClick={() => open("/video-" + item.id + ".html?url="+ encodeURI(item.collectionfile) + "&name="+ encodeURI(item.name))}>
                <Fragment>
                  <div class="title">{item.name}</div>
                  <div>{item.updateTime}</div>
                </Fragment>
              </li>)
            })
          }
        </ul>
      </div>
    )
  },
};
